// extracted by mini-css-extract-plugin
export default {"container":"edit-organization_container__9ySvy"};